import React, { Fragment } from "react";

import img13 from "../../../images/service/Blockchain Consulting/1.png";
import img14 from "../../../images/service/Blockchain Consulting/2.png";
import img15 from "../../../images/service/Blockchain Consulting/3.png";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Blockchain Strategy Consulting",
    content:
      "We analyze your business model and identify where blockchain adds real value, defining the right strategy and roadmap.",
  },
  {
    icon: sIcon2,
    title: "Use Case & Feasibility Analysis",
    content:
      "Evaluate technical feasibility, cost, scalability, and ROI before investing in blockchain development.",
  },
  {
    icon: sIcon3,
    title: "Architecture & Platform Selection",
    content:
      "Choose the right blockchain framework, consensus mechanism, and network type for long-term success.",
  },
];

const benefits = [
  {
    title: "Reduced Business Risk",
    description:
      "Expert consulting helps avoid costly design mistakes and ensures blockchain adoption is justified.",
    icon: sIcon1,
  },
  {
    title: "Clear Technology Direction",
    description:
      "Well-defined strategies eliminate confusion around platforms, protocols, and implementation paths.",
    icon: sIcon2,
  },
  {
    title: "Optimized Investment",
    description:
      "Assess costs, scalability, and ROI to ensure blockchain investments deliver measurable value.",
    icon: sIcon3,
  },
  {
    title: "Faster Time to Market",
    description:
      "Structured planning accelerates development and reduces rework during execution.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is blockchain consulting?",
    a: "Blockchain consulting helps businesses understand, plan, and implement blockchain solutions that align with their goals and technical requirements.",
  },
  {
    q: "When should a business seek blockchain consulting?",
    a: "Consulting is ideal before development to validate use cases, select platforms, and reduce implementation risks.",
  },
  {
    q: "Do you help with blockchain platform selection?",
    a: "Yes, we help choose the right blockchain such as Ethereum, Solana, Hyperledger, Polygon, or private networks.",
  },
  {
    q: "Can blockchain consulting reduce development costs?",
    a: "Absolutely. Proper planning prevents unnecessary development efforts and optimizes long-term costs.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function BlockchainConsulting() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Blockchain Consulting"
        pagesub="Strategic guidance for successful blockchain adoption"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Strategic{" "}
            <span className="gradient-text">Blockchain Consulting</span>{" "}
            Services
          </>
        }
        subtitle={`Make informed blockchain decisions with expert consulting services.
We help businesses identify use cases, select the right technology, and plan scalable blockchain solutions.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Blockchain Consulting"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is Blockchain Consulting?"
        image={img14}
        paragraphs={[
          "Blockchain consulting focuses on helping businesses evaluate whether blockchain is the right solution for their challenges. It involves understanding business goals, identifying suitable use cases, and defining a practical implementation strategy.",
          "Rather than jumping directly into development, consulting ensures that blockchain adoption is technically feasible, cost-effective, and aligned with long-term business objectives.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Blockchain Consulting Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Blockchain Consulting Is Critical"
        image={img15}
        paragraphs={[
          "Blockchain is not a one-size-fits-all technology. Without proper consulting, businesses risk investing in solutions that are complex, expensive, or unnecessary.",
          "Expert blockchain consulting helps organizations make informed decisions, avoid common pitfalls, and design architectures that scale securely and efficiently.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain Consulting"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Areas We Cover in Blockchain Consulting"
        subtitle="End-to-end advisory support for confident blockchain decisions."
        features={[
          {
            icon: sIcon1,
            title: "Use Case Identification",
            description:
              "Identify high-impact blockchain use cases tailored to your business domain.",
          },
          {
            icon: sIcon2,
            title: "Technology Evaluation",
            description:
              "Compare public, private, and hybrid blockchains based on performance and cost.",
          },
          {
            icon: sIcon3,
            title: "Architecture Design",
            description:
              "Define secure and scalable blockchain architectures before development.",
          },
          {
            icon: sIcon4,
            title: "Compliance & Security Planning",
            description:
              "Address regulatory requirements and security considerations early.",
          },
          {
            icon: sIcon5,
            title: "Cost & ROI Assessment",
            description:
              "Estimate development costs and long-term return on investment.",
          },
          {
            icon: sIcon6,
            title: "Implementation Roadmap",
            description:
              "Create a clear step-by-step roadmap from concept to deployment.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Experienced blockchain consultants and architects",
          "Business-first, technology-driven approach",
          "Proven frameworks for enterprise blockchain adoption",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
